import React from 'react';
import { Link } from 'react-router-dom';
import ServicesSubmenu from '../../components/ServicesSubmenu';
import '../../styles/ServiceDetail.css';

const EcommerceSolutions: React.FC = () => {
  return (
    <div className="service-detail-page">
      <section className="service-detail-hero">
        <div className="container">
          <h1>E-Commerce Solutions</h1>
          <p>Building Powerful Online Stores That Drive Sales</p>
        </div>
      </section>

      <ServicesSubmenu />

      <section className="service-overview">
        <div className="container">
          <div className="overview-content">
            <h2>Transform Your Business with E-Commerce</h2>
            <p>We create custom e-commerce solutions that help businesses sell online effectively. Our platforms are secure, scalable, and designed to provide an exceptional shopping experience for your customers.</p>
            <div className="key-features">
              <div className="feature-item">
                <i className="fas fa-shopping-cart"></i>
                <h3>Custom Stores</h3>
                <p>Tailored to your business needs</p>
              </div>
              <div className="feature-item">
                <i className="fas fa-lock"></i>
                <h3>Secure Payments</h3>
                <p>Multiple payment gateway options</p>
              </div>
              <div className="feature-item">
                <i className="fas fa-chart-line"></i>
                <h3>Sales Analytics</h3>
                <p>Detailed insights and reporting</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-details">
        <div className="container">
          <div className="details-grid">
            <div className="detail-item">
              <h3>Store Development</h3>
              <ul>
                <li>Custom e-commerce websites</li>
                <li>Product catalog management</li>
                <li>Shopping cart functionality</li>
                <li>Order management system</li>
              </ul>
            </div>
            <div className="detail-item">
              <h3>Payment Solutions</h3>
              <ul>
                <li>Multiple payment gateways</li>
                <li>Secure checkout process</li>
                <li>International payments</li>
                <li>Subscription billing</li>
              </ul>
            </div>
            <div className="detail-item">
              <h3>Inventory Management</h3>
              <ul>
                <li>Real-time stock tracking</li>
                <li>Multi-warehouse support</li>
                <li>Automated notifications</li>
                <li>Inventory analytics</li>
              </ul>
            </div>
            <div className="detail-item">
              <h3>Security Features</h3>
              <ul>
                <li>SSL certification</li>
                <li>PCI DSS compliance</li>
                <li>Fraud prevention</li>
                <li>Regular security updates</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="ecommerce-features">
        <div className="container">
          <h2>Advanced E-Commerce Features</h2>
          <div className="feature-grid">
            <div className="feature-item">
              <i className="fas fa-tags"></i>
              <h3>Product Management</h3>
              <ul>
                <li>Multiple product variants</li>
                <li>Bulk product import/export</li>
                <li>Digital products support</li>
                <li>Custom product attributes</li>
              </ul>
            </div>
            <div className="feature-item">
              <i className="fas fa-percent"></i>
              <h3>Marketing Tools</h3>
              <ul>
                <li>Discount and coupon system</li>
                <li>Abandoned cart recovery</li>
                <li>Email marketing integration</li>
                <li>Social media integration</li>
              </ul>
            </div>
            <div className="feature-item">
              <i className="fas fa-truck"></i>
              <h3>Shipping Integration</h3>
              <ul>
                <li>Multiple shipping methods</li>
                <li>Real-time shipping rates</li>
                <li>Order tracking</li>
                <li>International shipping</li>
              </ul>
            </div>
            <div className="feature-item">
              <i className="fas fa-chart-bar"></i>
              <h3>Analytics & Reporting</h3>
              <ul>
                <li>Sales analytics</li>
                <li>Customer behavior tracking</li>
                <li>Inventory reports</li>
                <li>Performance metrics</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="technologies">
        <div className="container">
          <h2>E-Commerce Platforms & Tools</h2>
          <div className="tech-stack">
            <div className="tech-category">
              <h3>Platforms</h3>
              <ul>
                <li><i className="fab fa-shopify"></i> Shopify</li>
                <li><i className="fab fa-wordpress"></i> WooCommerce</li>
                <li><i className="fab fa-magento"></i> Magento</li>
                <li><i className="fas fa-shopping-cart"></i> Custom Solutions</li>
              </ul>
            </div>
            <div className="tech-category">
              <h3>Payment Gateways</h3>
              <ul>
                <li><i className="fab fa-stripe"></i> Stripe</li>
                <li><i className="fab fa-paypal"></i> PayPal</li>
                <li><i className="fas fa-credit-card"></i> Square</li>
                <li><i className="fas fa-money-bill"></i> Custom Gateways</li>
              </ul>
            </div>
            <div className="tech-category">
              <h3>Analytics Tools</h3>
              <ul>
                <li><i className="fab fa-google"></i> Google Analytics</li>
                <li><i className="fas fa-chart-line"></i> Sales Analytics</li>
                <li><i className="fas fa-users"></i> Customer Analytics</li>
                <li><i className="fas fa-chart-pie"></i> Business Intelligence</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="success-stories">
        <div className="container">
          <h2>E-Commerce Success Stories</h2>
          <div className="stories-grid">
            <div className="story-item">
              <div className="story-content">
                <h3>200% Growth</h3>
                <p>Helped a fashion retailer achieve 200% growth in online sales within 6 months</p>
              </div>
            </div>
            <div className="story-item">
              <div className="story-content">
                <h3>50K+ Orders</h3>
                <p>Successfully handled over 50,000 orders for a food delivery platform</p>
              </div>
            </div>
            <div className="story-item">
              <div className="story-content">
                <h3>Global Reach</h3>
                <p>Expanded an local brand to serve customers in 15+ countries</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>Ready to Start Selling Online?</h2>
          <p>Let's build your e-commerce success story together</p>
          <Link to="/contact" className="cta-button">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default EcommerceSolutions; 